import React, { useState, useEffect } from 'react';
import { useToast } from '@chakra-ui/react';
import axios from 'axios';
import {
    Box,
    Flex,
    Text,
    Select,
    Td,
    Input,
    Stack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Spinner,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormControl,
    FormLabel,
    List,
    ListItem
} from '@chakra-ui/react';
import styles from '../Tabel.module.css';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

const VoucherTable = ({ lgType = "7" }) => {
    const toast = useToast();
    const [searchTerm, setSearchTerm] = useState('');
    const [searchType, setSearchType] = useState('ledger');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [voucherDetails, setVoucherDetails] = useState([]);
    const [loadingVoucher, setLoadingVoucher] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [currentVoucher, setCurrentVoucher] = useState(null);
    const [fromId , setFromId] = useState()
    const [toId, setToId] = useState();

    // const [cmpId] = useState(1); // Company ID
    const cmpId = sessionStorage.getItem('cmp_id')
    const [fromSuggestions, setFromSuggestions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);

    const [companyData, setCompanyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState(null);

    const [narationSuggestions, setNarationSuggestions] = useState([]);
    const [showDropdowns, setShowDropdowns] = useState(false);
    const [narration, setNarration] = useState(""); // State for "Narration" input
    const [narrationSuggestions, setNarrationSuggestions] = useState([]); // Correct spelling


    useEffect(() => {
        const fetchVoucherDetails = async () => {
            setLoadingVoucher(true);
            try {
                const response = await axios.post(`${ACCOUNTS_URL}/vouchers/voucher_list_all.php`, {
                    vo_typeid: lgType,
                    cmp_id: cmpId
                });
           
                if (response.data.success && Array.isArray(response.data.data)) {
                    setVoucherDetails(response.data.data);
                } else {
                    setVoucherDetails([]);
                    toast({
                        title: "Error",
                        description: response.data.message,
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                setVoucherDetails([]);
                toast({
                    title: "Error",
                    description: "Error fetching voucher details.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            } finally {
                setLoadingVoucher(false);
            }
        };

        // Fetch the voucher details immediately when the component mounts
        fetchVoucherDetails();

        // Set interval to refresh the data every 1 second (1000ms)
        const intervalId = setInterval(fetchVoucherDetails, 1000);

        // Clear the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, [lgType, cmpId, toast]);

    const filteredVouchers = voucherDetails.filter(voucher => {
        if (searchType === 'ledger') {
            return (
                voucher.from_ledger_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                voucher.to_ledger_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        } else if (searchType === 'voucher') {
            return voucher.voucher_no.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
            return true;
        }
    });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = filteredVouchers.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredVouchers.length / rowsPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };


    const fetchFromSuggestions = async (text) => {
        console.log(text);

        try {
            const response = await axios.post(`${ACCOUNTS_URL}/common/ledger_name.php`, {
                cmp_id: cmpId,
                fectxt: text
            });

            if (response.data.status === 'success') {
                setFromSuggestions(response.data.data);
            } else {
                setFromSuggestions([]);
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            setFromSuggestions([]);
        }
    };

    const fetchNarrationSuggestions = async (text) => {
        console.log(text);

        try {
            const response = await axios.post(`${ACCOUNTS_URL}/common/load_narration.php`, {
                cmp_id: cmpId,
                fectxt: text,
                vouch_type_id: 7
            });

            if (response.data.success) {
                setNarrationSuggestions(response.data.data);
                console.log('====================================');
                console.log(response.data.data);
                console.log('====================================');
            } else {
                setNarrationSuggestions([]);
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            setNarrationSuggestions([]);
        }
    };

    // Open edit modal and fetch details for the selected voucher
    const openEditModal = async (voucher) => {
        try {
            const response = await axios.post(`${ACCOUNTS_URL}/vouchers/edit_voucher.php`, {
                voucher_id: voucher.voucher_id,
                cmp_id: cmpId
            });

            console.log('====================================');
            console.log(response);
            console.log('====================================');
            if (response.data.success) {
                const voucherData = response.data.data[0]; // Assumes the response returns an array with one item
                setCurrentVoucher({
                    ...voucherData, // Populate all fields
                    from_ledger_name: voucherData.from_ledger_name,
                    to_ledger_name: voucherData.to_ledger_name,
                    vo_amount: voucherData.vo_amount,
                    narration: voucherData.narration || '',
                    voucher_date: voucherData.voucher_date,
                });
                setFromId(voucherData.fromledgerid); // Set fromledgerid
                setToId(voucherData.toledgerid); // Set fromledgerid


                setEditModalOpen(true);
            } else {
                toast({
                    title: "Error",
                    description: response.data.message,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: "Error fetching voucher details.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    const handleUpdateVoucher = async () => {
        const payload = {
            voucher_id: currentVoucher.voucher_id,
            voucher_no: currentVoucher.voucher_no,
            voucher_date: currentVoucher.voucher_date,
            from_ledger_name: fromId, // Use fromId (fromledgerid)
            to_ledger_name: currentVoucher.to_ledger_id ? currentVoucher.to_ledger_id : toId,
            vo_amount: currentVoucher.vo_amount, // Ensure it is a valid number
            narration: currentVoucher.narration || '',
            cmp_id: cmpId,
            user_id: sessionStorage.getItem('user_id'),
        };
        console.log('====================================');
        console.log(payload);
        console.log('====================================');
        try {
            const response = await axios.put(`${ACCOUNTS_URL}/vouchers/update_voucher.php`, payload);
            if (response.data.success) {
                toast({
                    title: "Success",
                    description: "Voucher updated successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                setVoucherDetails(prev =>
                    prev.map(v => (v.voucher_id === currentVoucher.voucher_id ? currentVoucher : v))
                );
            } else {
                toast({
                    title: "Error",
                    description: response.data.message,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: "Error updating voucher.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setEditModalOpen(false);
        }
    };


    // Function to handle voucher deletion
    const handleDeleteVoucher = async (voucherId) => {
        try {
            const response = await axios.post(`${ACCOUNTS_URL}/vouchers/delete_voucher.php`, {
                voucher_id: voucherId,
                cmp_id: cmpId,
            });

            if (response.data.success) {
                toast({
                    title: "Success",
                    description: "Voucher deleted successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                setVoucherDetails(prev => prev.filter(v => v.voucher_id !== voucherId));
            } else {
                toast({
                    title: "Error",
                    description: response.data.message,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Error",
                description: "Error deleting voucher.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    
    
    useEffect(() => {
        const storedUserId = sessionStorage.getItem('user_id');
        if (storedUserId) {
            setUserId(storedUserId);
        } else {
            setError('User not logged in or user_id not found in sessionStorage');
        }
    }, []);

    useEffect(() => {
        if (userId) {
            const fetchCompanyDetails = async () => {
                try {
                    const response = await fetch(`${ACCOUNTS_URL}/settings/company_details.php`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ user_id: userId }),
                    });

                    const data = await response.json();
                    console.log('====================================');
                    console.log(data);
                    console.log('====================================');
                    if (data.status === 200) {
                        setCompanyData(data.data);
                    } else {
                        setError('No company found for this user.');
                    }
                } catch (err) {
                    setError('Error fetching company details.');
                } finally {
                    setLoading(false);
                }
            };

            fetchCompanyDetails();
        }
    }, [userId]); // Run when userId is set




    function printVoucher() {
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '-9999px';
        document.body.appendChild(iframe);

        function numberToWords(num) {
            if (num === 0) return "Zero";
        
            const units = [
                "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"
            ];
            const teens = [
                "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
            ];
            const tens = [
                "", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
            ];
            const thousands = [
                "", "Thousand", "Million", "Billion"
            ];
        
            function chunk(num) {
                const parts = [];
                while (num > 0) {
                    parts.push(num % 1000);
                    num = Math.floor(num / 1000);
                }
                return parts;
            }
        
            function chunkToWords(chunk) {
                let result = "";
        
                if (chunk > 99) {
                    result += units[Math.floor(chunk / 100)] + " Hundred ";
                    chunk %= 100;
                }
                if (chunk > 10 && chunk < 20) {
                    result += teens[chunk - 11] + " ";
                } else {
                    if (chunk >= 10) {
                        result += tens[Math.floor(chunk / 10)] + " ";
                        chunk %= 10;
                    }
                    if (chunk > 0) {
                        result += units[chunk] + " ";
                    }
                }
                return result.trim();
            }
        
            const chunks = chunk(num);
            let word = "";
        
            for (let i = 0; i < chunks.length; i++) {
                if (chunks[i] > 0) {
                    word = chunkToWords(chunks[i]) + " " + thousands[i] + " " + word;
                }
            }
        
            return word.trim();
        }
        
        function amountToWords(amount) {
            const integerPart = Math.floor(amount);
            const decimalPart = Math.round((amount - integerPart) * 100);
            let words = numberToWords(integerPart) + " Rupees";
            if (decimalPart > 0) {
                words += " and " + numberToWords(decimalPart) + " Paise";
            }
            return words;
        }
        
        // Dynamically convert amount to words
        currentVoucher.vo_amount_words = amountToWords(currentVoucher.vo_amount || 0);
        
        // Log for debugging
        console.log(currentVoucher.vo_amount_words); // Example output: "One Thousand Two Hundred Thirty Four Rupees and Fifty Six Paise"
        


        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`
            <html>
                <head>
                    <style>
                        body { 
                            font-family: Arial, sans-serif; 
                            color: #333; 
                            margin: 0; 
                            padding: 20px; 
                        }
    
                        /* Centered Header Section */
                        .header {
                            text-align: center;
                            margin-bottom: 30px;
                        }
                        .header h2 { 
                            margin: 0; 
                            font-size: 22px; 
                            font-weight: bold; 
                        }
                        .header p {
                            margin: 2px 0; 
                            font-size: 14px; 
                        }
    
                        /* Recipient and Invoice Info */
                        .info-section {
                            display: flex;
                            justify-content: space-between;
                            margin-top: 30px;
                            margin-bottom: 20px;
                            font-size: 14px;
                        }
                        .info-section .left,
                        .info-section .right {
                            width: 50%;
                        }
                        .info-section p {
                            margin: 5px 0;
                        }

                         .info-section .right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* Ensures items start from the top */
    align-items: flex-end; /* Aligns content to the right edge */
    text-align: right; /* Aligns text inside the container to the right */
}

    
                        /* Amount Table */
                        .amount-table {
                            width: 100%; 
                            border-collapse: collapse; 
                            margin-top: 20px; 
                            font-size: 14px;
                        }
                        .amount-table th, .amount-table td { 
                            border: 1px solid #ddd; 
                            padding: 8px; 
                            text-align: left; 
                        }
                        .amount-table th {
                            background-color: #f9f9f9; 
                            font-weight: bold; 
                            text-align: center;
                        }
                        .amount-table td:last-child, .amount-table th:last-child {
                            text-align: right;
                        }
    
                        /* Footer Note */
                        .footer-note {
                            margin-top: 20px; 
                            text-align: center; 
                            font-size: 12px; 
                        }

                        .amount-table tbody tr:first-child td {
    height: 260px; /* Applies to the first row */
    vertical-align: top;
}

                    </style>
                </head>
                <body>
                    <!-- Centered Header Section -->
                    <div class="header">
    ${companyData.Company_Name && companyData.Company_Name.startsWith("No") === false 
        ? `<h2>${companyData.Company_Name}</h2>` 
        : ""}
    ${companyData.address && companyData.address.startsWith("No") === false 
        ? `<p>${companyData.address}</p>` 
        : ""}
    ${companyData.Tin && companyData.Tin.startsWith("No") === false 
        ? `<p>GSTIN/UIN: ${companyData.Tin}</p>` 
        : ""}
    ${companyData.Email_Id && companyData.Email_Id.startsWith("No") === false 
        ? `<p>Email: ${companyData.Email_Id}</p>` 
        : ""}
</div>

    
                    <!-- Recipient and Invoice Info Section -->
                    <div class="info-section">
                     <div class="left">
    <p><strong>Buyer (Bill to):</strong></p>
    ${currentVoucher.from_ledger_name && currentVoucher.from_ledger_name.startsWith("No") === false 
        ? `<p>${currentVoucher.from_ledger_name}</p>` 
        : ""}
    ${currentVoucher.from_ledger_address && currentVoucher.from_ledger_address.startsWith("No") === false 
        ? `<p>${currentVoucher.from_ledger_address}</p>` 
        : ""}
    ${currentVoucher.from_customer_place && currentVoucher.from_customer_place.startsWith("No") === false 
        ? `<p>${currentVoucher.from_customer_place}</p>` 
        : ""}
    ${currentVoucher.from_customer_tin && currentVoucher.from_customer_tin.startsWith("No") === false 
        ? `<p>GSTIN/UIN: ${currentVoucher.from_customer_tin}</p>` 
        : ""}
</div>


                        <div class="right">
                            <p><strong>Date:</strong> ${currentVoucher.voucher_date.split(' ')[0] || ""}</p>
                            <p><strong>Invoice No:</strong>${currentVoucher.voucher_no || ""}</p>
                        </div>
                    </div>
    
                    <!-- Amount Table -->
                    <table class="amount-table">
                        <thead>
                            <tr>
                                <th>Sl No.</th>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>${currentVoucher.to_ledger_name || "Description"}</td>
                                <td style="font-weight: bold;"> ${currentVoucher.vo_amount || "0.00"}</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="text-align: right;">Total</td>
                                <td style="font-weight: bold;">${currentVoucher.vo_amount || "0.00"}</td>
                            </tr>
                            <tr>
                                <td colspan="3" style="text-align: center;">${currentVoucher.vo_amount_words}</td>
                            </tr>
                        </tbody>
                    </table>
    
                    <!-- Footer Note -->
                    <div class="footer-note">
                        <p>For ${currentVoucher.from_ledger_name ? currentVoucher.from_ledger_name : ""}</p>
                    </div>
                </body>
            </html>
        `);
        iframeDoc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        iframe.remove();
    }

    


    return (
        <Box borderWidth="1px" mt={3} borderRadius="20px" bg='white'>
           <Flex 
    justify="space-between" 
    align="center" 
    borderTopWidth="1px" 
    mb={1} 
    p={3} 
    flexWrap="wrap"
>
    <Flex 
        align="center" 
        flexWrap="wrap" 
        mb={{ base: 2, md: 0 }}
    >
        <Text mr={2}>Rows Per Page</Text>
        <Select
            width={{ base: '80px', md: '100px' }}
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
            mr={2}
        >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
        </Select>
        <Text>Entries</Text>
    </Flex>

    <Flex 
        align="center" 
        flexWrap="wrap"
        justify={{ base: 'center', md: 'flex-end' }}
    >
        <Select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            width={{ base: '120px', md: '200px' }}
            borderColor="#E9EDF4"
            mr={{ base: 2, md: 4 }}
            w={{base:'100%'}}
        >
            <option value="ledger">Ledger</option>
            <option value="voucher">Voucher No</option>
        </Select>
        <Input
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            width={{ base: '100%', md: 'auto' }}
            borderColor="#E9EDF4"
            mr={{ base: 0, md: 3 }}
            mt={{ base: 2, md: 0 }}
        />
    </Flex>
</Flex>

            <Box style={{ overflowX: 'auto', width: '100%' }} w={{ base: '367px', md: '100%' }} className={styles.Table}>
                <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
                    <Thead>
                        <Tr>
                            <Th>Voucher No</Th>
                            <Th>Date</Th>
                            <Th>Particulars</Th>
                            <Th textAlign='right'>Debit</Th>
                            <Th textAlign='right'>Credit</Th>
                            <Th>Actions</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentData.length > 0 ? (
                            currentData.map(detail => (
                                <React.Fragment key={detail.voucher_id}>
                                    <Tr>
                                        <Td>{detail.voucher_no}</Td>
                                        <Td>{detail.voucher_date.split(' ')[0]}</Td>
                                        <Td>{detail.from_ledger_name}</Td>
                                        <Td textAlign='right'>{detail.debit_amount}</Td>
                                        <Td textAlign='right'>0.00</Td>
                                        <Td>
                                            <Button colorScheme="blue" onClick={() => openEditModal(detail)}>
                                                Edit
                                            </Button>
                                            <Button colorScheme="red" ml={2} onClick={() => handleDeleteVoucher(detail.voucher_id)}>
                                                Delete
                                            </Button>
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td>{detail.voucher_no}</Td>
                                        <Td>{detail.voucher_date.split(' ')[0]}</Td>
                                        <Td>{detail.to_ledger_name}</Td>
                                        <Td textAlign='right'>0.00</Td>
                                        <Td textAlign='right'>{detail.credit_amount}</Td>
                                        <Td />
                                    </Tr>
                                </React.Fragment>
                            ))
                        ) : (
                            <Tr>
                                <Td colSpan={6} textAlign="center">No vouchers found</Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>

                {/* Pagination controls */}
                <Flex justify="end" borderTopWidth="1px" mt={1} p={3}>
                    <Button onClick={() => handlePageChange(currentPage - 1)} isDisabled={currentPage === 1}>
                        Prev
                    </Button>
                    <Stack direction="row" mx={2}>
                        {currentPage > 1 && (
                            <>
                                <Button onClick={() => handlePageChange(1)}>1</Button>
                                {currentPage > 2 && <Text>...</Text>}
                            </>
                        )}
                        <Button backgroundColor='#ff8f00' color="white">{currentPage}</Button>
                        {currentPage < totalPages - 1 && (
                            <>
                                <Text>...</Text>
                                <Button onClick={() => handlePageChange(totalPages)}>{totalPages}</Button>
                            </>
                        )}
                    </Stack>
                    <Button onClick={() => handlePageChange(currentPage + 1)} isDisabled={currentPage === totalPages}>
                        Next
                    </Button>
                </Flex>
            </Box>


            {/* Edit Modal */}
            <Modal isOpen={editModalOpen} onClose={() => setEditModalOpen(false)}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Edit Voucher</ModalHeader>
                    <ModalBody>
                        <Stack spacing={4}>
                            <FormControl>
                                <FormLabel>Voucher No</FormLabel>
                                <Input
                                    placeholder="Voucher No"
                                    value={currentVoucher?.voucher_no || ''}
                                    onChange={(e) => setCurrentVoucher(prev => ({ ...prev, voucher_no: e.target.value }))}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>Voucher Date</FormLabel>
                                <Input
                                    placeholder="Voucher Date"
                                    type="date"
                                    value={
                                        currentVoucher?.voucher_date
                                            ? currentVoucher.voucher_date.split(' ')[0]  // Extracts just the date part
                                            : ''
                                    }
                                    onChange={(e) =>
                                        setCurrentVoucher({ ...currentVoucher, voucher_date: e.target.value + " 00:00:00" })
                                    }
                                />
                            </FormControl>


                            <FormControl>
                                <FormLabel>To Ledger Name</FormLabel>
                                <Input
                                    placeholder="From Ledger Name"
                                    value={currentVoucher?.from_ledger_name || ''}
                                    onChange={(e) => setCurrentVoucher(prev => ({ ...prev, from_ledger_name: e.target.value }))}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>From Ledger Name</FormLabel>
                                <Input
                                    placeholder="To Ledger Name"
                                    value={currentVoucher?.to_ledger_name || ''}
                                    onChange={(e) => {
                                        const updatedVoucher = { ...currentVoucher, to_ledger_name: e.target.value };
                                        setCurrentVoucher(updatedVoucher);
                                        if (e.target.value.length >= 1) {
                                            fetchFromSuggestions(e.target.value);
                                            setShowDropdown(true); // Show the dropdown when fetching suggestions
                                        } else {
                                            setShowDropdown(false); // Hide the dropdown if input is less than 1 character
                                        }
                                    }}
                                />
                                {showDropdown && fromSuggestions.length > 0 && (
                                    <Box
                                        border="1px solid #ccc"
                                        borderRadius="md"
                                        mt={1}
                                        maxH="150px"
                                        overflowY="auto"
                                        bg="white"
                                        zIndex={1}
                                        position="absolute"
                                        w="100%"
                                    >
                                        <List spacing={0}>
                                            {fromSuggestions.map((suggestion) => (
                                                <ListItem
                                                    key={suggestion.Ldg_id}
                                                    p={2}
                                                    _hover={{ backgroundColor: 'gray.100', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        const updatedVoucher = {
                                                            ...currentVoucher,
                                                            to_ledger_name: suggestion.L_name,
                                                            to_ledger_id: suggestion.Ldg_id
                                                        };
                                                        setCurrentVoucher(updatedVoucher);
                                                        setShowDropdown(false);
                                                    }}
                                                >
                                                    {suggestion.L_name}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                )}
                                {showDropdown && fromSuggestions.length === 0 && (
                                    <Text p={2}>No suggestions found</Text>
                                )}
                            </FormControl>

                            <FormControl>
                                <FormLabel>Amount</FormLabel>
                                <Input
                                    placeholder="Amount"
                                    type="number"
                                    value={currentVoucher?.vo_amount ? currentVoucher.vo_amount.replace(/,/g, '') : ''}
                                    onChange={(e) => {
                                        setCurrentVoucher(prev => ({ ...prev, vo_amount: e.target.value }));
                                    }}
                                />
                            </FormControl>

                            <FormControl mb={4}>
                                <FormLabel>Narration</FormLabel>
                                <Input
                                    value={currentVoucher?.narration || ''} // Using currentVoucher to manage narration state
                                    onChange={(e) => {
                                        setCurrentVoucher(prev => ({ ...prev, narration: e.target.value })); // Update narration in state
                                        if (e.target.value.length >= 1) {
                                            fetchNarrationSuggestions(e.target.value);
                                            setShowDropdowns(true); // Show dropdown if input is sufficient
                                        } else {
                                            setShowDropdowns(false); // Hide dropdown if input is less than 2 characters
                                        }
                                    }}
                                />
                                {showDropdowns && narrationSuggestions.length > 0 && (
                                    <Box
                                        border="1px solid #ccc"
                                        borderRadius="md"
                                        mt={1}
                                        maxH="150px"
                                        overflowY="auto"
                                        bg="white"
                                        zIndex={1}
                                        position="absolute"
                                        w="100%"
                                    >
                                        <List spacing={0}>
                                            {narrationSuggestions.map((suggestion) => (
                                                <ListItem
                                                    key={suggestion.v_naretion}
                                                    p={2}
                                                    _hover={{ backgroundColor: 'gray.100', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setCurrentVoucher(prev => ({ ...prev, narration: suggestion.v_naretion })); // Set selected narration
                                                        setShowDropdowns(false); // Hide dropdown after selection
                                                    }}
                                                >
                                                    {suggestion.v_naretion}
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                )}

                                {showDropdowns && narrationSuggestions.length === 0 && (
                                    <Text p={2}>No suggestions found</Text>
                                )}
                            </FormControl>
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" onClick={() => { handleUpdateVoucher();}}>
                            Save
                        </Button>
                        <Button ml={3} onClick={() => setEditModalOpen(false)}>
                            Cancel
                        </Button>
                        <Button ml={3} colorScheme="teal" onClick={() => {
                            handleUpdateVoucher();
                            printVoucher();
                        }}>
                            Save & Print
                        </Button>

                    </ModalFooter>
                </ModalContent>
            </Modal>

        </Box>
    );
};

export default VoucherTable;
